import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TextField from 'material-ui/TextField';
import { Button } from '@atoms';
import { ResetPasswordForm, FormContainer } from './layout';
import messages from './messages';

export default class ResetPassword extends Component {
  static propTypes = {
    resetPassword: PropTypes.func.isRequired,
    isReseting: PropTypes.bool,
    userId: PropTypes.number,
  };

  static defaultProps = {
    isReseting: false,
    userId: null,
  };

  state = {
    password: null,
  };

  resetPassword = () => this.props.resetPassword(this.state.password, this.props.userId);

  handlePasswordChange = (evt, target) => {
    this.setState({ password: target });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.resetPassword();
  };

  render() {
    return (
      <ResetPasswordForm onSubmit={this.handleSubmit}>
        <FormContainer>
          <TextField
            onChange={this.handlePasswordChange}
            style={{ width: '100%' }}
            floatingLabelText={<FormattedMessage {...messages.password} />}
            value={this.state.password ? this.state.password : ''}
            type="password"
          />
          <Button
            primary
            small
            type="submit"
            id="reset-password"
            fullWidth
            loading={this.props.loginLoading}
          >
            <FormattedMessage {...messages.reset} />
          </Button>
        </FormContainer>
      </ResetPasswordForm>
    );
  }
}



// WEBPACK FOOTER //
// ./components/molecules/ResetPassword/ResetPassword.js